module.exports = __webpack_public_path__ + "img/pending_zone.99c9efd1.svg";